const name = 'deleted-orders';

export const GET_ORDERS_LIST_REQUEST = `${name}/GET_ORDERS_LIST_REQUEST`;
export const GET_ORDERS_LIST_SUCCESS = `${name}/GET_ORDERS_LIST_SUCCESS`;
export const GET_ORDERS_LIST_FAILURE = `${name}/GET_ORDERS_LIST_FAILURE`;

export const GET_ORDERS_TABLE_CONFIGURATION_REQUEST = `${name}/GET_ORDERS_TABLE_CONFIGURATION_REQUEST`;
export const GET_ORDERS_TABLE_CONFIGURATION_SUCCESS = `${name}/GET_ORDERS_TABLE_CONFIGURATION_SUCCESS`;
export const GET_ORDERS_TABLE_CONFIGURATION_FAILURE = `${name}/GET_ORDERS_TABLE_CONFIGURATION_FAILURE`;

export const RESTORE_ORDER_DETAILS_REQUEST = '${name}/RESTORE_ORDER_DETAILS_REQUEST';
export const RESTORE_ORDER_DETAILS_SUCCESS = '${name}/RESTORE_ORDER_DETAILS_SUCCESS';
export const RESTORE_ORDER_DETAILS_FAILURE = '${name}/RESTORE_ORDER_DETAILS_FAILURE';

export default name;
